import { useEffect, useRef } from 'react'

const useOnOutsideClick = (fn, isActive = true) => {
  const ref = useRef()

  useEffect(() => {
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return
      }

      fn(event)
    }

    const addListeners = () => {
      document.addEventListener('mousedown', listener)
      document.addEventListener('touchstart', listener)
    }

    const removeListeners = () => {
      document.removeEventListener('mousedown', listener)
      document.removeEventListener('touchstart', listener)
    }

    if (isActive) {
      addListeners()
    } else {
      removeListeners()
    }

    return () => removeListeners()
  }, [ref, fn, isActive])

  return ref
}

export default useOnOutsideClick
